import React from 'react'
import uuid  from 'uuid'

sleep = (ms) ->
  new Promise (resolve) -> setTimeout(resolve, ms)

export default class Recaptcha extends React.Component
  constructor: (props) ->
    super(props)

    @id     = uuid.v4()
    @suffix = uuid.v4().replace(/-/g, '')

    window['recaptchaVerifiedCallback' + @suffix] = props.onVerify
    window['recaptchaExpiredCallback'  + @suffix] = props.onExpire or (->)

  componentWillUnmount: ->
    delete window['recaptchaVerifiedCallback' + @suffix]
    delete window['recaptchaExpiredCallback'  + @suffix]

  render: ->
    <div id={@id} className="g-recaptcha" data-sitekey={@props.siteKey}
         data-callback={'recaptchaVerifiedCallback' + @suffix}
         data-expired-callback={'recaptchaExpiredCallback' + @suffix}>
    </div>

  componentDidMount: ->
    while not window.recaptchaReady
      await sleep(100)

    result = window.grecaptcha.render(@id)
